module.exports = __webpack_public_path__ + "src/img/time.074c1870.svg";